// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"e636f863","787":"11fee7c5"}[chunkId] + ".chunk.js";
};